import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUserListExcludedData } from "./rolebaseAPI";
export interface UserListExcludedState {
  userListExcludedData: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: UserListExcludedState = {
  userListExcludedData: [],
  status: "idle",
};

export const GetUserListExcludedData = createAsyncThunk("UserListExcluded/fetchUserListExcludedData", async (data:any) => {
  const response = await fetchUserListExcludedData(data);
  return response;
});

export const UserListExcludedSlice = createSlice({
  name: "UserListExcluded",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUserListExcludedData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUserListExcludedData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetUserListExcludedData.fulfilled, (state, action) => {
        state.status = "success";
        state.userListExcludedData = action.payload.user;
      });
  },
});

export const {} = UserListExcludedSlice.actions;

export const selectUserListExcludedData = (state: RootState) => {
  return state.UserListExcluded.userListExcludedData;
};

export default UserListExcludedSlice.reducer;
